module.exports = vendors_ru_03400e7d77ef7900f0ac;